import { VStack, View } from "@gluestack-ui/themed";

import { PageContainer } from "../PageContainer";
import { StatusCard } from "./components/StatusCard";
import { StatusScreenScaffoldProps } from "./types";
import { StatusScreenThemeMap } from "./constants";

export const StatusScreenScaffold = ({
  title,
  subtitle,
  subtitleMaxWidth,
  type,
}: StatusScreenScaffoldProps) => {
  const theme = StatusScreenThemeMap[type];

  return (
    <View
      w="$full"
      h="$full"
      flex={1}
      minHeight={"$100vh"}
      backgroundColor={theme.backgroundColor}
    >
      <PageContainer>
        <VStack alignItems="center" justifyContent="center">
          <StatusCard
            title={title}
            subtitle={subtitle}
            subtitleMaxWidth={subtitleMaxWidth}
            icon={theme.icon}
            iconColor={theme.fontColor}
          />
        </VStack>
      </PageContainer>
    </View>
  );
};

export default StatusScreenScaffold;
